export default __webpack_public_path__ + "static/media/img5.21a760fb.svg";